{
  "overridesEnabledBadgeLabel": "Overrides on"
}
